import { render, staticRenderFns } from "./ElementRow.vue?vue&type=template&id=a4a527a4&"
import script from "./ElementRow.vue?vue&type=script&lang=js&"
export * from "./ElementRow.vue?vue&type=script&lang=js&"
import style0 from "./ElementRow.vue?vue&type=style&index=0&id=a4a527a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports